import styles from "./HomeCard.module.css";
import Card from "react-bootstrap/Card";
import { BsFillCaretRightFill } from "react-icons/bs";

const HomeCard = ({ card }) => {
  return (
    <Card className={`${styles.homeCard} ${styles[card.color]}`}>
      <Card.Body className="d-flex align-items-center">
        <Card.Title>
          <h2>{ card.name } </h2>
        </Card.Title>
      </Card.Body>
      <Card.Footer className={styles.homeCardFooter}>
        <div className={styles.homeCardButton}>
          <span className={styles.homeCardButton}>{ card.desc }</span>
          <span className={styles.homeCardButton}>
            <BsFillCaretRightFill />
          </span>
        </div>
      </Card.Footer>
    </Card>
  );
};

export default HomeCard;
